import { RootState } from "../reducers";

export const getUrlShortenerData = (state: RootState) => state.urlShortener?.data;
export const getUrlShortenerLoading = (state: RootState) => state.urlShortener?.loading;
export const getUrlShortenerError = (state: RootState) => state.urlShortener?.error;
export const getShortenedUrlResult = (state: RootState) =>
  state.urlShortener?.data?.shorturl || state.urlShortener?.data?.longUrl || "";
